import axios, { AxiosError } from "axios"

import i18nData from "../locales/zh-CN.json"

const request = axios.create({
    baseURL: __SERVER_PREFIX,
    responseType: "json",
    timeout: 10000,
})


console.log('__SERVER_PREFIX',__SERVER_PREFIX)
request.interceptors.request.use(
    (config) => {
        return config
    },
    (error) => {
        return {
            code: -1,
            msg: error.message ?? i18nData["tips.request.error"],
        }
    }
)

request.interceptors.response.use(
    (response) => {
        return response.data
    },
    (error: AxiosError) => {
        const url: string = error.request?.responseURL || ""
        if (!url.endsWith("/info")) {
            console.error(error)
        }

        const resData = error.response?.data as any

        if (resData) {
            return {
                code: resData.code ?? resData.statusCode,
                msg: resData.msg ?? resData.message,
            }
        }

        return {
            code: -1,
            msg:
                error.response?.statusText ??
                error.message ??
                i18nData["tips.request.error"],
        }
    }
)

export default request
